import React from 'react';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Link from './Link';

function Element(props: any) {
  const classes = useStyles();

  const { attributes, children, element, editor, isDefaultEditor } = props;
  // (note - pearl) We do not allow headings in default editor, the heading elements will get
  // rendered as regular text

  const defaultElement = (
    <div {...attributes} {...element.attr} className={classNames(classes.root, classes.textLine)}>
      {children}
    </div>
  );

  switch (element.type) {
    case 'list-item':
      return (
        <li {...attributes} {...element.attr} className={classes.textLine}>
          {children}
        </li>
      );
    case 'orderedList':
      return (
        <ol {...attributes} className={classNames(classes.ol, classes.textLine)}>
          {children}
        </ol>
      );
    case 'unorderedList':
      return (
        <ul {...attributes} className={classNames(classes.ul, classes.textLine)}>
          {children}
        </ul>
      );
    case 'heading_one':
      return (
        <>
          {isDefaultEditor ? (
            defaultElement
          ) : (
            <h1
              {...attributes}
              {...element.attr}
              className={classNames(classes.headingOne, classes.textLine)}
            >
              {children}
            </h1>
          )}
        </>
      );
    case 'heading_two':
      return (
        <>
          {isDefaultEditor ? (
            defaultElement
          ) : (
            <h2
              {...attributes}
              {...element.attr}
              className={classNames(classes.headingTwo, classes.textLine)}
            >
              {children}
            </h2>
          )}
        </>
      );
    case 'heading_three':
      return (
        <>
          {isDefaultEditor ? (
            defaultElement
          ) : (
            <h3
              {...attributes}
              {...element.attr}
              className={classNames(classes.headingThree, classes.textLine)}
            >
              {children}
            </h3>
          )}
        </>
      );
    case 'link':
      return <Link {...props} editor={editor} />;
    default:
      return defaultElement;
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: 14,
  },
  headingOne: {
    fontSize: 24,
  },
  headingTwo: {
    fontSize: 18,
  },
  headingThree: {
    fontSize: 16,
  },
  ol: {
    paddingInlineStart: '12px',
  },
  ul: {
    paddingInlineStart: '16px',
  },
  textLine: {
    margin: 0,
    marginBottom: theme.spacing(),
  },
}));

export default Element;
